import * as model from "@/model/adm/UserSetting";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.UserSetting(), newFilter)
    .withStates({
        idReport: 2,
        // entityAux: null,
        baseModuleUrl : process.env.VUE_APP_ADM_API_URL + "adm-service/adm",
        rolesLabel:[
            {key:'roleName',label:'lbl.role.resources.resourceType'},
            {key:'locationName',label:'lbl.role.resources.scopes'}
        ],
    })
    .withMutations({
        deleteRole(state, index) {
            state.entity.roles.splice(index,1);
        }
    }) 
    .buildStore()
